module.exports = __webpack_public_path__ + "static/media/information-outline.654c76ca.svg";